import React from 'react';
import { Container, Form, Row, Col } from 'react-bootstrap';
import styles from './EditEvolucao.module.scss';
import { useConsulta } from '../contexts/ConsultaContext';
import FormLabel from './FormLabel';
import Button from './Button';
import { fetchAuth } from '../utils/fetchAuth';


const EditEvolucao: React.FC = () => {
    const { consulta, setConsulta } = useConsulta();
    const [saving, setSaving] = React.useState(false);

    const modified = (() => {
        const edited = consulta?.evolucao?.last_edited;
        const updated = consulta?.evolucao?.last_updated;

        if (!edited || !updated) return false;

        return new Date(edited) > new Date(updated);
    })();

    return (
        <>
            <Container>
                <h5 className="mb-3">Evolução</h5>
            </Container>
            <Container>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <FormLabel
                                htmlFor='resumoEvolucao'
                            >
                                Resumo:
                            </FormLabel>
                            <textarea
                                id='resumoEvolucao'
                                className={[styles['text-area-control'], 'form-control'].join(' ')}
                                rows={3}
                                defaultValue={consulta?.evolucao?.resumo || ''}
                                onChange={(e) => {
                                    let updatedConsulta = consulta ? { ...consulta } : null;
                                    if (!updatedConsulta)
                                        updatedConsulta = {
                                            id: -1,
                                            title: '',
                                            last_modified: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    if (!updatedConsulta.evolucao)
                                        updatedConsulta.evolucao = {
                                            id: -1,
                                            progresso: '',
                                            condutas_futuras: '',
                                            resumo: '',
                                            last_updated: (new Date()).toISOString(),
                                        };
                                    updatedConsulta.evolucao.resumo = e.target.value;
                                    updatedConsulta.evolucao.last_edited = (new Date()).toISOString();
                                    setConsulta(updatedConsulta);
                                }}
                            ></textarea>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <FormLabel
                                htmlFor='progresso'
                            >
                                Progresso:
                            </FormLabel>
                            <textarea
                                id='progresso'
                                className={[styles['text-area-control'], 'form-control'].join(' ')}
                                rows={3}
                                defaultValue={consulta?.evolucao?.progresso || ''}
                                onChange={(e) => {
                                    let updatedConsulta = consulta ? { ...consulta } : null;
                                    if (!updatedConsulta)
                                        updatedConsulta = {
                                            id: -1,
                                            title: '',
                                            last_modified: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    if (!updatedConsulta.evolucao)
                                        updatedConsulta.evolucao = {
                                            id: -1,
                                            progresso: '',
                                            condutas_futuras: '',
                                            resumo: '',
                                            last_updated: (new Date()).toISOString(),
                                        };
                                    updatedConsulta.evolucao.progresso = e.target.value;
                                    updatedConsulta.evolucao.last_edited = (new Date()).toISOString();
                                    setConsulta(updatedConsulta);
                                }}
                            ></textarea>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <FormLabel
                                htmlFor='condutasFuturas'
                            >
                                Condutas futuras:
                            </FormLabel>
                            <textarea
                                id='condutasFuturas'
                                className={[styles['text-area-control'], 'form-control'].join(' ')}
                                rows={3}
                                defaultValue={consulta?.evolucao?.condutas_futuras || ''}
                                onChange={(e) => {
                                    let updatedConsulta = consulta ? { ...consulta } : null;
                                    if (!updatedConsulta)
                                        updatedConsulta = {
                                            id: -1,
                                            title: '',
                                            last_modified: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    if (!updatedConsulta.evolucao)
                                        updatedConsulta.evolucao = {
                                            id: -1,
                                            progresso: '',
                                            condutas_futuras: '',
                                            resumo: '',
                                            last_updated: (new Date()).toISOString(),
                                        };
                                    updatedConsulta.evolucao.condutas_futuras = e.target.value;
                                    updatedConsulta.evolucao.last_edited = (new Date()).toISOString();
                                    setConsulta(updatedConsulta);
                                }}
                            ></textarea>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button
                            disabled={!modified || saving}
                            onClick={() => {
                                if (!consulta) return;
                                setSaving(true);
                                fetchAuth(`${process.env.REACT_APP_API_URL}/consultorio/consultations/${consulta.id}/evolucao`, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                        observacoes: consulta?.evolucao?.resumo || '',
                                        progresso: consulta?.evolucao?.progresso || '',
                                        condutas_futuras: consulta?.evolucao?.condutas_futuras || '',
                                    }),
                                })
                                    .then(async response => {
                                        if (!response.ok) {
                                            const errorData = await response.json();
                                            throw new Error(errorData.message || 'Erro ao salvar evolução');
                                        }
                                        return response.json();
                                    })
                                    .then(data => {
                                        if (!consulta) return;
                                        setConsulta({
                                            ...consulta,
                                            evolucao: {
                                                id: -1,
                                                progresso: consulta.evolucao?.progresso || '',
                                                condutas_futuras: consulta.evolucao?.condutas_futuras || '',
                                                resumo: consulta.evolucao?.resumo || '',
                                                last_updated: (new Date()).toISOString(),
                                                last_edited: (new Date()).toISOString(),
                                            },
                                        });

                                    })
                                    .catch(error => {
                                        console.error('Erro ao salvar:', error);
                                    })
                                    .finally(() => {
                                        setSaving(false);
                                    });

                            }}
                        >
                            {modified ? (saving ? 'Salvando' : 'Salvar') : 'Salvo'}
                        </Button>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default EditEvolucao;
